<ng-container >
    <div class="row">
        <!-- temporary stats -->
        <div class="col-md-6 col-lg-4 col-xxl-2/5">
            <mat-card class="single-stats-box tagus-card mb-25">
                <div class="d-flex align-items-center">
                    <div class="icon">
                        <i class="flaticon-purpose"></i>
                    </div>
                    <div class="title">
                        <h3>{{counts?.totalAgents}}</h3>
                        <span class="gray-color d-block">Total Agents</span>
                    </div>
                </div>
            </mat-card>
        </div>

        <div class="col-md-6 col-lg-4 col-xxl-2/5">
            <mat-card class="single-stats-box tagus-card mb-25">
                <div class="d-flex align-items-center">
                    <div class="icon">
                        <i class="flaticon-to-do-list"></i>
                    </div>
                    <div class="title">
                        <h3>{{counts?.totalApplications}}</h3>
                        <span class="gray-color d-block">Total Applications</span>
                    </div>
                </div>
            </mat-card>
        </div>

        <div class="col-md-6 col-lg-4 col-xxl-2/5">
            <mat-card class="single-stats-box tagus-card mb-25">
                <div class="d-flex align-items-center">
                    <div class="icon bg2">
                        <i class="flaticon-learning"></i>
                    </div>
                    <div class="title">
                        <h3>{{counts?.totalCourses}}</h3>
                        <span class="gray-color d-block">Total Courses</span>
                    </div>
                </div>
            </mat-card>
        </div>

        <div class="col-md-6 col-lg-4 col-xxl-2/5">
            <mat-card class="single-stats-box tagus-card mb-25">
                <div class="d-flex align-items-center">
                    <div class="icon bg2">
                        <i class="flaticon-people"></i>
                    </div>
                    <div class="title">
                        <h3>{{counts?.totalStudent}}</h3>
                        <span class="gray-color d-block">Total Student</span>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="col-md-6 col-lg-4 col-xxl-2/5">
            <mat-card class="single-stats-box tagus-card mb-25">
                <div class="d-flex align-items-center">
                    <div class="icon">
                        <i class="flaticon-home"></i>
                    </div>
                    <div class="title">
                        <h3>{{counts?.totalUniversity}}</h3>
                        <span class="gray-color d-block">Total University</span>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
    <div class="row mb-25" *ngIf="powerBiToken">
        <div class="col-6 mb-25" *ngIf="showToOnlySeniors()">
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="'Payment By Country'" [embedToken]="powerBiToken" [pageName]="'559261f52109018dcc80'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'" >
            </app-powerbi-widget>
        </div>
        <div class="col-6 mb-25" *ngIf="showToOnlySeniors()">
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="'Payment By RM'" [embedToken]="powerBiToken" [pageName]="'8895e39c2b2689296190'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'"></app-powerbi-widget>
        </div>
        <div class="col-12 mb-25" *ngIf="showToOnlySeniors()">
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="'Payment By University'" [embedToken]="powerBiToken" [pageName]="'a287a69b4d86e43be12d'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'" >
            </app-powerbi-widget>
        </div>
        <div class="col-12 mb-25" *ngIf="showSeniorCPTReports() && false">
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="'CPT Data'" [embedToken]="powerBiToken" [pageName]="'b7f02514926bbe444762'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'" >
            </app-powerbi-widget>
        </div>
        <div class="col-12 mb-25" *ngIf="showToOnlySeniors()">
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="'Agent Logged In Summary'" [embedToken]="powerBiToken" [pageName]="'d6cdb80d0a02be5d15e5'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'" ></app-powerbi-widget>
        </div>
        <div class="col-12" *ngIf="showJuniorCPTReports() && false">
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="'CPT Data'" [embedToken]="powerBiToken" [pageName]="'555c59625e64ab45fc15'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'" [reportFilter]="this.userDetails?.roles?.[0]?.id === '130' ?[{tableName:'ApplicationStatusSummaryTable', columnName:'UserName', value:[powerBiFilters?.userName]}]:[]"></app-powerbi-widget>
        </div>
    </div>

</ng-container>

<ng-container *ngIf="showRMDashboard">
    <div class="row mb-25" *ngIf="powerBiToken">
        <div class="col-12 mb-25" >
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="''" [embedToken]="powerBiToken" [pageName]="'627a5604dcda1be0943b'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'" [reportFilter]="[{tableName:'agents', columnName:'AgentRMStatus', value:[this.powerBiFilters?.userName]}]"> agents
            </app-powerbi-widget>
        </div>
        <div class="col-12 mb-25" >
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="''" [embedToken]="powerBiToken" [pageName]="'78a88e1c7e9b99936b33'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'"></app-powerbi-widget>
        </div>
        <div class="col-12 mb-25" >
            <app-powerbi-widget class="mat-mdc-card mdc-card single-stats-box tagus-card" [reportHeight]="'500'" [title]="'Payment By University'" [embedToken]="powerBiToken" [pageName]="'bd7133a8a00961d33a5d'" [reportId]="'8be5d7b6-3c38-4287-94dc-39f202447a94'" [reportFilter]="[{tableName:'agents', columnName:'AgentRMStatus', value:[this.powerBiFilters?.userName]}]">
            </app-powerbi-widget>
        </div>
    </div>
</ng-container>